import React, { useEffect, useState } from "react";
import { HashLink } from "react-router-hash-link";
import "./header.css";
import { useUserAuth } from "../../context/userAuthContext";
import { handleLogOut, handleSignIn } from "../../Utility/utils";
const Header = () => {
  const {user, googleSignIn, logOut} = useUserAuth();
  const [hasShadow, setHasShadow] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [activeLink, setActiveLink] = useState('');

  const Home = <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M261.56 101.28a8 8 0 00-11.06 0L66.4 277.15a8 8 0 00-2.47 5.79L63.9 448a32 32 0 0032 32H192a16 16 0 0016-16V328a8 8 0 018-8h80a8 8 0 018 8v136a16 16 0 0016 16h96.06a32 32 0 0032-32V282.94a8 8 0 00-2.47-5.79z"></path><path d="M490.91 244.15l-74.8-71.56V64a16 16 0 00-16-16h-48a16 16 0 00-16 16v32l-57.92-55.38C272.77 35.14 264.71 32 256 32c-8.68 0-16.72 3.14-22.14 8.63l-212.7 203.5c-6.22 6-7 15.87-1.34 22.37A16 16 0 0043 267.56L250.5 69.28a8 8 0 0111.06 0l207.52 198.28a16 16 0 0022.59-.44c6.14-6.36 5.63-16.86-.76-22.97z"></path></svg>;

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  useEffect(() => {
    const handleScroll = () => {
      if(window.scrollY > 0){
        setHasShadow(true);
        setShowMenu(false);
      }else{
        setHasShadow(false);
        handleLinkClick('home');
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={`HeaderContainer ${hasShadow ? "shadow-header" : ""}`}>
      <div className="Header-Left-Content">
        <div className="HamburgerButton" onClick={toggleMenu}>
          {showMenu ? "✕" : "☰"}
        </div>
        <div className="HeaderLogo"> 
          <HashLink 
            className="nav-link active" 
            smooth to={`/#`}
            onClick={() => handleLinkClick('home')}
          >
            {Home}  
          </HashLink>
        </div>
      </div>
      <div className="Header-Right-Content">
        <div className={`HeaderContent ${showMenu ? "show" : ""}`}>
          <div className="HeaderLink">
            <HashLink
              smooth to='/#about'
              className={activeLink === "about" ? 'nav-link active' : 'nav-link'}
              onClick={() => handleLinkClick('about')}
            >
              About
            </HashLink>
          </div>
          <div className="HeaderLink">
            <HashLink 
              smooth to ='/#services'
              className={activeLink === "service" ? 'nav-link active' : 'nav-link'}
              onClick={() => handleLinkClick('service')}
            >
              Services
            </HashLink>
          </div>
          <div className="HeaderLink">
            <HashLink
              smooth to ='/#projects'
              className={activeLink === "project" ? 'nav-link active' : 'nav-link'}
              onClick={() => handleLinkClick('project')}
            >
              Projects
            </HashLink></div>
          <div className="HeaderLink">
            <HashLink 
              smooth to='/#contact'
              className={activeLink === "contact" ? 'nav-link active' : 'nav-link'}
              onClick={() => handleLinkClick('contact')}
            >
              Contact
            </HashLink>
          </div>
        </div>
        <div>
            {
            user?
              <button className="btn" onClick={() => handleLogOut(logOut)}>
                Logout
              </button>
              :
              <button className="btn" onClick={() => handleSignIn(googleSignIn)}>
                Signin
              </button>
            }
          </div>
      </div>
    </div>
  );
};

export default Header;
